<template>
    <div>
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <b-form-select
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                type="text"
                autocomplete="no"
                :placeholder="field.placeholder"
                :disabled="loading || isDisabled"
                :options="options"
                :text-field="textField"
                :value-field="valueField"
                :data-vv-name="field.label"
                class="form-control custom-select"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
            >
                <option slot="first" :value="null" disabled>
                    {{ field.placeholder }}
                </option>
            </b-form-select>
        </b-form-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
        dataSegmentId: {
            type: String,
            required: true,
        },
        textField: {
            type: String,
            default: 'text',
        },
        valueField: {
            type: String,
            default: 'value',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            value: null,
            options: [],
            isDisabled: false,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading']),

        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                if (this.field.isLocked) {
                    return this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    return customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: newValue,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: newValue,
                        },
                    })
                }
            }, // End of set() method
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        /*
        |--------------------------------------------------------------------------
        | Did this for BANK ALFALAH AMC REQUIREMENT
        |--------------------------------------------------------------------------
        */
        if (this.field.key == 'accountInfo.operateAccount') {
            let newValue = 'Only the Principal Account Holder'
            this.writeValue(newValue)
            this.isDisabled = true
        }

        // End of BANK ALFALAH AMC REQUIREMENT

        // update the options field from props
        this.options = this.field.options

        // initialize if custom field
        if (!this.field.isLocked) {
            this.$store.commit('initCustomField', {
                key: `${this.field._id}`,
                value: {
                    title: this.field.label,
                    type: this.field.type,
                    value: null,
                },
            })
        }
    }, // End of Component > mounted

    created() {
        // Watching CRS Form for Tax Residency Self Certification -> Reason
        if (this.field.key == 'fatcaInfo.CountryTax') {
            this.isDisabled = true
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.fatcaInfo
                        .CountryTaxOption
                },
                (newValue) => {
                    //console.log('Key is fatcaInfo.CountryTax ')
                    if (newValue == 'Yes') {
                        //console.log(newValue)
                        this.isDisabled = false
                        this.field.isRequired = true
                    } else {
                        this.isDisabled = true
                        this.field.isRequired = false
                    }
                }
            )
        } // End
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /*
        |--------------------------------------------------------------------------
        | Manually setting the value of Dropdown
        |--------------------------------------------------------------------------
        */
        writeValue(newValue) {
            this.value = newValue
            if (this.field.isLocked) {
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue,
                })
            } else {
                this.$store.commit('updateField', {
                    key: `customInfo.${this.field._id}`,
                    value: {
                        title: this.field.label,
                        type: this.field.type,
                        value: newValue,
                    },
                })
            }
        }, // End of Method > writeValue
    },
}
</script>
